var map = {
	"./icon-BRO.svg": "L7kh",
	"./icon-BUL.svg": "+P/d",
	"./icon-CBR.svg": "Bm7G",
	"./icon-DOL.svg": "frLP",
	"./icon-Defence.svg": "JR+E",
	"./icon-Footwork.svg": "HfOq",
	"./icon-Footy_IQ.svg": "n/og",
	"./icon-GCT.svg": "Wxi6",
	"./icon-General_kicking.svg": "/iSl",
	"./icon-Goal_kicking.svg": "3Euz",
	"./icon-Leadership.svg": "t2cm",
	"./icon-MEL.svg": "FCo0",
	"./icon-MNL.svg": "pEa3",
	"./icon-NEW.svg": "Mf9H",
	"./icon-NQC.svg": "EnAY",
	"./icon-NZL.svg": "8DJG",
	"./icon-PAR.svg": "slAP",
	"./icon-PTH.svg": "8SAe",
	"./icon-Physicality.svg": "6ILM",
	"./icon-Power.svg": "4BwH",
	"./icon-SHA.svg": "clUx",
	"./icon-STG.svg": "4XRi",
	"./icon-STH.svg": "YhHY",
	"./icon-SYD.svg": "VP6a",
	"./icon-Speed.svg": "qoT9",
	"./icon-Utility_value.svg": "8NNc",
	"./icon-WST.svg": "CSxR",
	"./icon-Work_rate.svg": "efqS",
	"./icon-X-factor.svg": "ruPz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "QYwg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/icon\-.*\.svg$
// module id = QYwg
// module chunks = 0